import { Box, Text } from '@chakra-ui/react';

export const TextPreview = () => {
  return (
    <Box>
      <Text>TextPreview - Coming soon</Text>
    </Box>
  );
};
